import { INVITATION_TOKEN } from "@/api/schemas/invitations";

const CLAVE = "ads:invitacion-pendiente";

/**
 * La invitación que se está aceptando, solo mientras la persona está en Google: si entra con otra cuenta, el
 * servidor la devuelve a `/entrar?federated_error=invitation_mismatch` SIN el token (no se reflejan datos), y
 * esto permite traerla de vuelta a su invitación. `sessionStorage` (pestaña) y con la forma del token comprobada.
 */
export function guardarInvitacionPendiente(token: string): void {
  try {
    sessionStorage.setItem(CLAVE, token);
  } catch {
    // Sin almacenamiento, un fallo de cuenta caerá en la pantalla de entrar; no hay nada más que hacer.
  }
}

export function leerInvitacionPendiente(): string | null {
  try {
    const token = sessionStorage.getItem(CLAVE);
    return token && INVITATION_TOKEN.test(token) ? token : null;
  } catch {
    return null;
  }
}

export function olvidarInvitacionPendiente(): void {
  try {
    sessionStorage.removeItem(CLAVE);
  } catch {
    // Nada que olvidar.
  }
}
